<template>
    <v-dialog
        v-model="$store.state.transacting.unfinalizedCause"
        persistent
        max-width="600px"
    >
        <v-card>
            <v-toolbar dense dark color="secondary" class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Unifinalize Cause
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.transacting.unfinalizedCause = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid >
                <v-form 
                 v-model="valid"
                lazy-validation 
                ref="form">
                    <v-combobox
                    label="Select Cause"
                    dense
                    required
                    :items="causes"
                    :item-text="'Cause'"
                    :item-value="'ID'"
                    :rules="[
        				   v =>
            					!!v ||
            					'Cause is required'
    					   ]"
                    auto-select-first
                    v-model="idCause"
                ></v-combobox>
                <v-textarea
                    dense
                    required
                    rows="5"
                    label="Comment"
                    :rules="[
        				   v =>
            					!!v ||
            					'Comment is required'
    					   ]"
                    v-model="comment"
                    hide-details
                ></v-textarea>
                </v-form>
            </v-container>
            <v-container>
                <v-row justify="end">
                     <v-btn color="primary" class="mr-5 mb-2" @click="validate">Save</v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props:['ShiftDetail'],
    data: function() {
        return {
            causes: [],
            valid:true,
            id: null,
            idCause: null,
            comment: null,
        };
    },
    mounted() {
        this.loadUnifinalizeCause();
    },
    methods: {
        loadUnifinalizeCause: function() {
            var str = this.$store;
            axios
                .get('unifinalized-cause', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.causes = response.data;
                    console.log(this.causes);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                });
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
              this.unfinalizedShift();
            }
        },
        unfinalizedShift: function(){
            var str = this.$store;
           
                var parms = {
                CauseID: this.idCause.ID,
                Comment: this.comment,
                ShiftDetail: this.ShiftDetail
                }
            console.log(parms);
            str.state.isLoading = true;
            axios
                .post('shifts-unifinalized/create/put',parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    this.$store.state.transacting.watch = true;
                    this.$store.state.transacting.unfinalizedCause = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
            
            
        },
       
    }
};
</script>
